<div class="row derivativeNav">
    <div class="col-lg-2 col-md-2 col-sm-2 mb-1">
        <button id="sidebarCollapse" class="pl-2 pr-2 menuclick" type="button" (click)="clicktoggle()">
            <i class="fa fa-bars" [ngClass]="fullscreen ? '' : 'hide'" aria-hidden="true"></i>
            <svg [ngClass]="fullscreen ? 'hide' : ''" xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                fill="currentColor" class="bi bi-x-lg i-close" viewBox="0 0 16 16">
                <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
            </svg>
            <span class="sr-only"> click here</span>
        </button>
    </div>
    <div class="col-lg-10 col-md-10 col-sm-10">
        <app-derivative-header (derivativeChange)="changeDerivative($event)"></app-derivative-header>
    </div>
</div>
<div class="fullwrapper">
    <app-derivative-sidebar [derivative]="derivative" [ngClass]="fullscreen ? 'active' : ''"></app-derivative-sidebar>
    <div id="content" (click)="hideSidebar()">
        <router-outlet></router-outlet>
    </div>
</div>